export const CATEGORIES_GET_REQUEST = "@categories.get.request";
export const CATEGORIES_GET_SUCCESS = "@categories.get.success";
export const CATEGORIES_GET_FAIL = "@categories.get.failure";

export const CATEGORY_LOAD_REQUEST = "@category.load.request";
export const CATEGORY_LOAD_SUCCESS = "@category.load.success";
export const CATEGORY_LOAD_FAIL = "@category.load.failure";

export const CATEGORY_CREATE_REQUEST = "@category.create.request";
export const CATEGORY_CREATE_SUCCESS = "@category.create.success";
export const CATEGORY_CREATE_FAIL = "@category.create.failure";
export const CATEGORY_CREATE_DONE = "@category.create.done";

export const CATEGORY_UPDATE_REQUEST = "@category.update.request";
export const CATEGORY_UPDATE_SUCCESS = "@category.update.success";
export const CATEGORY_UPDATE_FAIL = "@category.update.failure";
export const CATEGORY_UPDATE_DONE = "@category.update.done";
